// src/components/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        
        {/* Column 1: Brand & Contact */}
        <div style={styles.brandCol}>
          <h2 style={styles.brandName}>NAPREV</h2>
          <p style={styles.brandDesc}>
            Empowering your growth through intelligent solutions. We merge strategic business insight with advanced technological innovation to help you make smarter, faster decisions.
          </p>
          <div style={styles.contactInfo}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E1261C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '10px' }}>
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <a href="mailto:workforceus2016@gmail.com" style={styles.contactLink}>WorkForceUS2016@gmail.com</a>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div style={styles.linksCol}>
          <h3 style={styles.colTitle}>Quick Links</h3>
          <div style={styles.linkList}>
            <Link to="/" onClick={scrollToTop} style={styles.link}>Home</Link>
            <Link to="/services" onClick={scrollToTop} style={styles.link}>Services</Link>
            <Link to="/resources" onClick={scrollToTop} style={styles.link}>Insights & Resources</Link>
            <Link to="/about" onClick={scrollToTop} style={styles.link}>About Us</Link>
            <Link to="/contact" onClick={scrollToTop} style={styles.link}>Contact Us</Link>
            <Link to="/privacy-policy" onClick={scrollToTop} style={styles.link}>Privacy Policy</Link>
          </div>
        </div>

        {/* Column 3: Locations (Side by Side) */}
        <div style={styles.locationsCol}>
          <h3 style={styles.colTitle}>Global Offices</h3>
          <div style={styles.locationsWrapper}>
            <div style={styles.locationBox}>
              <div style={styles.locationHeader}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E1261C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
                </svg>
                <h4 style={styles.locationCity}>India (GCC)</h4>
              </div>
              <p style={styles.locationText}>
                Hyderabad, Telangana<br />
                India
              </p>
            </div>
            
            <div style={styles.locationBox}>
              <div style={styles.locationHeader}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E1261C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
                </svg>
                <h4 style={styles.locationCity}>United States</h4>
              </div>
              <p style={styles.locationText}>
                Pleasanton, California<br />
                United States
              </p>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: '#001524',
    color: '#D1D5DB',
    padding: '60px 5% 40px',
    fontFamily: 'Arial, sans-serif',
    borderTop: '4px solid #E1261C'
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '40px',
    justifyContent: 'space-between'
  },
  brandCol: {
    flex: '1 1 300px',
    display: 'flex',
    flexDirection: 'column'
  },
  brandName: {
    fontSize: '28px',
    color: '#FFFFFF',
    fontWeight: 'bold',
    margin: '0 0 15px 0',
    letterSpacing: '1px'
  },
  brandDesc: {
    fontSize: '15px',
    lineHeight: '1.6',
    color: '#9CA3AF',
    marginBottom: '20px'
  },
  contactInfo: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 'auto'
  },
  contactLink: {
    color: '#FFFFFF',
    textDecoration: 'none',
    fontSize: '15px',
    fontWeight: '500',
    transition: 'color 0.2s ease'
  },
  linksCol: {
    flex: '1 1 200px'
  },
  colTitle: {
    fontSize: '18px',
    color: '#FFFFFF',
    fontWeight: 'bold',
    marginBottom: '20px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  linkList: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px 20px'
  },
  link: {
    color: '#9CA3AF',
    textDecoration: 'none',
    fontSize: '15px',
    transition: 'color 0.2s ease',
    display: 'inline-block'
  },
  locationsCol: {
    flex: '2 1 400px'
  },
  locationsWrapper: {
    display: 'flex',
    gap: '40px',
    flexWrap: 'wrap'
  },
  locationBox: {
    flex: '1',
    minWidth: '180px',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    padding: '20px',
    borderRadius: '8px',
    borderLeft: '3px solid #E1261C'
  },
  locationHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px'
  },
  locationCity: {
    fontSize: '16px',
    color: '#FFFFFF',
    fontWeight: 'bold',
    margin: 0
  },
  locationText: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#9CA3AF',
    margin: 0
  }
};

export default Footer;